import axios from 'api/axios';

const SEND_ACTIVITY_PATH = '/gw/datalake_front_receiver/v1/send_activity';

export function sendSearchActivity(): void {
  void axios.post(SEND_ACTIVITY_PATH, {}).catch(() => {});
}
